import {EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {CommonUtils} from "../utils/common";
import {AppStateService} from "../providers/app-state.service";
import {Observable, Subscription} from "rxjs";
import {User} from "../models/user.model";
import {ModalController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {TranslatedPage} from "../pages/translated.page";
import {GenericObject} from "../models/generic-object.model";
import {VImage} from "../models/vet-clinic.model";

export class GenericActionComponent implements OnInit, OnDestroy {

  @Input() user: User;
  @Input() csrfToken: string;
  @Input() titleOnAdd: string;
  @Input() titleOnEdit: string;
  @Input() action: 'ADD' | 'EDIT';
  @Output() actionCanceledEmitter = new EventEmitter<Boolean>();

  public formGroup: FormGroup;

  public isBusy: boolean;
  protected isBusySub: Subscription;

  public componentTitle: string;

  public actionBtnLabel: string;
  public actionQuestion: string;
  public actionSuccess: string;
  public actionError: string;

  public hasUnsavedChanges = false;
  public images: VImage[];
  private initializeTranslation: boolean = true;
  private language: string;

  constructor(
    public  commonUtilsLib: CommonUtils,
    private appStateServiceLib: AppStateService,
    private modalControllerLib: ModalController,
    private translateServiceLib: TranslateService,
  ) {
  }

  ngOnInit() {
    this.isBusySub = this.appStateServiceLib.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    })

    this._initTranslate();
  }

  _translateLanguage(): void {
    this.translateServiceLib.use(this.language);
  }

  translationExist(key: string): boolean {
    return this.translateServiceLib.instant(key) !== key;
  }

  _initTranslate() {
    console.log('_initTranslate');
    if (this.initializeTranslation && !TranslatedPage.translationInInitialized) {
      // Set the default language for translation strings, and the current language.
      this.translateServiceLib.setDefaultLang('pl');
      this.language = 'pl';

      // if (this.translateServiceLib.getBrowserLang() !== undefined && this.language !== this.translateServiceLib.getBrowserLang()) {
      //   this.translateServiceLib.setDefaultLang('en');
      //   this.language = 'en';
      // } else {
      //   this.language = 'pl';
      // }

      this._translateLanguage();
    }
  }

  handleActionMethod(serviceMethod: Observable<GenericObject>, objectAddedEmitter: EventEmitter<GenericObject>, objectEditedEmitter: EventEmitter<GenericObject>, errorEmitter: EventEmitter<String> = null) {
    this.appStateServiceLib.updateIsBusySubject(true);

    serviceMethod.subscribe((obj: GenericObject) => {
        this.appStateServiceLib.updateIsBusySubject(false);
        if (obj && obj.uuid) {
          this.commonUtilsLib.presentInfoToast(this.actionSuccess).then(res => {
            if (this.action === 'ADD') {
              objectAddedEmitter.emit(obj);
            } else {
              objectEditedEmitter.emit(obj);
            }
            this.hasUnsavedChanges = false;
          });
        } else {
          this.commonUtilsLib.presentAlertToast(this.actionError);
        }
      },
      error => {
      if (errorEmitter!== null) {
        errorEmitter.emit(error.message)
      }
      this.appStateServiceLib.updateIsBusySubject(false);
      this.commonUtilsLib.presentAlertToast(this.actionError);
    });
  }

  isFormFieldInvalid(form: FormGroup, fieldName: string, validationType: string) {
    return this.commonUtilsLib.isFormFieldInvalid(form, fieldName, validationType);
  }

  isFormInvalid(form: FormGroup, validationType: string) {
    return this.commonUtilsLib.isFormInvalid(form, validationType);
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
      this.appStateServiceLib.updateEditMode("CHANGED");
    }
  }


  onCancelAction() {
    if (this.hasUnsavedChanges) {
      this.commonUtilsLib.presentYesNoActionSheet('Masz niezapisane zmiany. Na pewno chcesz zrezygnować z wprowadzonych zmian?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.actionCanceledEmitter.emit(true);
        this.appStateServiceLib.updateEditMode("NONE");
      }, () => {
      });
    } else {
      this.appStateServiceLib.updateIsBusySubject(false);
      this.actionCanceledEmitter.emit(true);
    }
  }

  ngOnDestroy() {
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
  }

  getTitle(): string {
    if (this.action && this.action === 'EDIT') {
      return (this.titleOnEdit ? this.titleOnEdit : undefined);
    } else {
      return (this.titleOnAdd ? this.titleOnAdd : undefined);
    }
  }

  hasTitleDefined() {
    return this.getTitle() !== undefined;
  }
}

export interface GenericActionComponentsMethods {
  onAction(): void
}
